import {
  __statistics__invoices
} from "./__statistics__invoices";
import {
  __statistics__tax_invoices
} from "./__statistics__tax_invoices";

// .replace(/[/]/g, "__").replace(/[-]/g, "_")

export const testDatas = {
  "/statistics/tax-invoices": __statistics__tax_invoices,
  "/statistics/invoices": __statistics__invoices,
}